module.exports = __webpack_public_path__ + "img/goal-two-en.06ab3f40.png";